import React from 'react';
import { Breadcrumbs, H5 } from '../../../AbstractElements';
import { Col, Container, Row } from 'reactstrap';
import { FeaturedTutorials } from '../../../Constant';
import Articals from './Articals';
import FeaturesTutorial from './FeaturesTutorial';
import HeaderPart from './HeaderPart';

const KnowledgeBaseContain = () => {
  return (
    <Container fluid={true} className='faq-section'>
      <Breadcrumbs pageTitle='Knowledgebase' parent='Knowledgebase' title='Knowledgebase' />
      <Row>
        <HeaderPart />
        <Articals />
        <Col lg='12' className='featured-tutorial'>
          <div className='header-faq'>
            <H5 className='mb-0'>{FeaturedTutorials}</H5>
          </div>
          <Row>
            <FeaturesTutorial />
          </Row>
        </Col>
      </Row>
    </Container>
  );
};
export default KnowledgeBaseContain;
